import React, { useEffect, useState } from 'react'
import { Tooltip, Dialog, DialogActions, DialogTitle, DialogContent, FormControl, Snackbar, Alert, FormLabel, RadioGroup, Radio, FormControlLabel, Button, DialogContentText, TextField } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import WarningIcon from '@mui/icons-material/Warning';
import { getApiUrl } from '../../env';
import axios from 'axios';

const Bias = ({ biases = [], showText, showFlag, newsItemId, showBias }) => {

    const [open, setOpen] = useState(false)
    const [openSnack, setOpenSnack] = useState("closed")
    const [selectedBias, setSelectedBias] = useState(1);
    const [additionalComment, setAdditionalComment] = useState("");

    const handleClose = ev => {
        console.log(selectedBias, additionalComment);
        axios.post(getApiUrl() + "feedback/bias", { "comment": additionalComment, "suggestedBias": selectedBias, "newsItemId": newsItemId })
            .then(res => {
                setOpen(false)
                setOpenSnack("success")
            })
            .catch(er => {
                setOpen(false)
                setOpenSnack("error")
            })
    }
    return (
        <div style={{ width: '100%', textAlign: 'center', display:showBias ? 'block' : 'none' }}>
            <div style={{ display: 'inline-block', width: showFlag ?'70%' : "100%", verticalAlign: 'middle' }}>
                <div style={{ width: '100%', height: '5px', display: 'flex', borderRadius: '5px' }}>
                    <Tooltip title={'Пристрасно кон СДСМ ' + (Math.round(biases[0] * 10000) / 100).toFixed(2) + '%'} placement="top">
                        <div style={{ flex: biases[0], height: '100%', backgroundColor: '#93CAED' }}>&nbsp;</div>
                    </Tooltip>
                    <Tooltip title={'Неутрално ' + (Math.round(biases[1] * 10000) / 100).toFixed(2) + '%'} placement="top">
                        <div style={{ flex: biases[1], height: '100%', backgroundColor: '#F5F5DC' }}>&nbsp;</div>
                    </Tooltip>
                    <Tooltip title={'Пристрасно кон ВМРО ' + (Math.round(biases[2] * 10000) / 100).toFixed(2) + '%'} placement="top">
                        <div style={{ flex: biases[2], height: '100%', backgroundColor: '#F47174' }}>&nbsp;</div>
                    </Tooltip>
                </div>
            </div>
            {showFlag ?
                <div style={{ display: 'inline-block', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => setOpen(true)}>
                    <Tooltip title={'Не е точна пристрасноста?'}>
                        <FlagIcon fontSize="small" />
                    </Tooltip>
                </div>
                : <></>}
            {showText ?
                <div style={{ display: 'inline-block', fontSize: '0.875rem', verticalAlign: 'middle', marginLeft: '5px' }}>
                    {biases.indexOf(Math.max(...biases)) == 1 ? 'Неутрално ' + (Math.round(biases[1] * 10000) / 100).toFixed(2) + '%'
                        : biases.indexOf(Math.max(...biases)) == 0 ? 'Пристрасно кон СДСМ ' + (Math.round(biases[0] * 10000) / 100).toFixed(2) + '%'
                            : 'Пристрасно кон ВМРО ' + (Math.round(biases[2] * 10000) / 100).toFixed(2) + '%'
                    }
                </div>
                : <></>}
            <Dialog open={open} onClose={()=>setOpen(false)}>
                <DialogTitle>Погрешна пристрасност</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Одбери ја пристрасноста на <b>текстот</b> на оваа вест според тебе.
                    </DialogContentText>
                    <FormControl style={{ width: '100%' }}>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={1}
                            name="radio-buttons-group"
                            value={selectedBias}
                            onChange={(ev) => setSelectedBias(ev.target.value)}
                        >
                            <FormControlLabel value={1} control={<Radio />} label="Неутрално" />
                            <FormControlLabel value={0} control={<Radio />} label="Пристрасно кон СДСМ" />
                            <FormControlLabel value={2} control={<Radio />} label="Пристрасно кон ВМРО-ДПМНЕ" />
                        </RadioGroup>
                        <TextField
                            value={additionalComment}
                            onChange={(ev) => setAdditionalComment(ev.target.value)}
                            autoFocus
                            label="Дополнителен коментар (незадолжително)"
                            variant="standard"
                        />
                    </FormControl>
                    <br />
                    <DialogContentText style={{ fontSize: '12px', marginTop: '10px' }}>
                        <WarningIcon fontSize='small' color='warning' style={{ verticalAlign: 'middle', marginRight: '3px' }} />Внимавајте да ја внесете пристрасноста конкретно на оваа вест објавена од овој портал, не општо на порталот.
                        <br /><br /> Политичката пристрасност се одредува со модел на машинско учење кој не е перфектен и понекогаш прави грешки, но со твоја помош може да се подобри.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Откажи</Button>
                    <Button onClick={handleClose}>Прати</Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={openSnack != "closed"} autoHideDuration={6000} onClose={() => setOpenSnack("closed")} anchorOrigin={{ horizontal:"center", vertical:"top" }}>
                {openSnack == "success" ?
                    <Alert onClose={() => setOpenSnack("closed")} severity="success" sx={{ width: '100%' }}>
                        Фала ти!
                    </Alert>
                    : openSnack == "error" ?
                    <Alert onClose={() => setOpenSnack("closed")} severity="error" sx={{ width: '100%' }}>
                        Се случи грешка
                    </Alert>
                    : <div></div>
                }
            </Snackbar>
        </div>
    )
}

export default Bias;